import { comparisonData } from '@/mocks/homeData';

export default function ComparisonSection() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* Left: Text + Table */}
          <div className="flex-1 w-full lg:w-5/12">
            <span className="inline-block px-3 py-1 rounded-full border border-accent-300 text-xs font-semibold text-accent-600 bg-accent-50 mb-4 whitespace-nowrap">
              Updated Weekly
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Why AllChinaBuy
              <span className="block text-accent-600 font-light italic">Spreadsheet Wins</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              The <strong>AllChinaBuy Spreadsheet</strong> eliminates the guesswork from product research.
              Instead of spending hours scrolling through unorganized listings, access a structured,
              regularly updated database of products with real QC photos and verified seller information.
            </p>

            {/* Stats */}
            <div className="flex items-center gap-8 mt-8">
              <div>
                <span className="font-heading text-3xl md:text-4xl font-bold text-primary-500">50K+</span>
                <p className="text-xs text-foreground-500 mt-1">Curated Products</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div>
                <span className="font-heading text-3xl md:text-4xl font-bold text-accent-500">14</span>
                <p className="text-xs text-foreground-500 mt-1">Categories</p>
              </div>
            </div>
          </div>

          {/* Right: Comparison Table + Images */}
          <div className="flex-1 w-full lg:w-7/12 space-y-6">
            {/* Comparison Table */}
            <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-background-200/70">
                    <th className="text-left px-5 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                      Feature
                    </th>
                    <th className="text-center px-5 py-3 text-xs font-semibold text-accent-600 uppercase tracking-wider bg-accent-50/50">
                      AllChinaBuy Spreadsheet
                    </th>
                    <th className="text-center px-5 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                      Manual Search
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonData.map((row, idx) => (
                    <tr key={idx} className="border-b border-background-200/50 last:border-none">
                      <td className="px-5 py-3 text-sm text-foreground-800 font-medium">
                        {row.feature}
                      </td>
                      <td className="px-5 py-3 text-center bg-accent-50/30">
                        {typeof row.spreadsheet === 'boolean' ? (
                          row.spreadsheet ? (
                            <i className="ri-check-line text-accent-500 text-base font-bold"></i>
                          ) : (
                            <i className="ri-close-line text-foreground-400 text-base"></i>
                          )
                        ) : (
                          <span className="text-sm font-semibold text-accent-600">{row.spreadsheet}</span>
                        )}
                      </td>
                      <td className="px-5 py-3 text-center">
                        {typeof row.manual === 'boolean' ? (
                          row.manual ? (
                            <i className="ri-check-line text-foreground-400 text-base"></i>
                          ) : (
                            <i className="ri-close-line text-foreground-300 text-base"></i>
                          )
                        ) : (
                          <span className="text-sm text-foreground-500">{row.manual}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Image cards */}
            <div className="grid grid-cols-2 gap-3">
              <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20trendy%20sneakers%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20flat%20lay%20with%20gentle%20shadows%2C%20editorial%20style%2C%20neutral%20tones%2C%20high%20quality%20ecommerce%20product%20shot%20with%20organized%20composition&width=600&height=600&seq=comp-img-shoes-acb-v3&orientation=squarish"
                  alt="AllChinaBuy Spreadsheet featured sneakers category"
                  title="AllChinaBuy Spreadsheet - Shoes Category"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="aspect-square rounded-xl overflow-hidden bg-background-200 -mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20oversized%20hoodie%20laid%20flat%20on%20a%20clean%20beige%20surface%2C%20minimalist%20product%20photography%20with%20soft%20diffused%20daylight%2C%20neutral%20cream%20and%20warm%20tone%20aesthetic%2C%20high%20detail%20fabric%20texture%2C%20editorial%20fashion%20shot%20with%20clean%20composition&width=600&height=600&seq=comp-img-hoodie-acb-v3&orientation=squarish"
                  alt="AllChinaBuy Spreadsheet hoodies and sweaters category"
                  title="AllChinaBuy Spreadsheet - Hoodies Category"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}